module.exports = __webpack_public_path__ + "img/food-and-drinking-icon.57115151.svg";